
import React from 'react'

export const TextFinderVenues = ({ setTextToFind }) => {
  const handlerOnChange = (event) => {
    // console.log(event.target.value)
    setTextToFind(event.target.value.toLowerCase())
  }
  return (
        <div className="col-lg-4 col-12 px-1">
        <div className="input-group">
          <input type="text" onChange={handlerOnChange} className="text-input pe-5 rounded" placeholder="Buscar venues" />
          <i className="bx bx-search position-absolute top-50 end-0 translate-middle-y me-3 zindex-5 fs-lg" />
        </div>
      </div>
  )
}
